/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';

import { SocialChannels } from '@toucan/client/shared/components/social-channels';

import { SignUpFunnel } from '@toucan/client/blocks/components/sign-up-funnel';

import { JoinNowTile } from '../join-now-tile';
import { styles } from './social-footer.styles';

const StyledSocialFooter = styled.section`
    ${styles}
`;

export const SocialFooter: FunctionComponent = () => {
    const { setModalContent, setModalVisible, setModalSize } =
        useContext(ApplicationContext);

    const { t } = useTranslation();

    const openLoginModal = () => {
        setModalSize(ModalSize.LARGE);
        setModalContent(<SignUpFunnel />);
        setModalVisible(true);
    };

    return (
        <StyledSocialFooter>
            <JoinNowTile openModal={openLoginModal} />
            <div className="social-wrapper">
                <Heading className="mpb-hash" size={HeadingSize.H4}>
                    #<span className="mpb-hash-highlight">mpbcom</span>
                </Heading>
                <div className="social">
                    <p className="social-title">{t('Follow us')}</p>
                    <SocialChannels className="social-icons" />
                </div>
            </div>
        </StyledSocialFooter>
    );
};
